import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";
import { formatPrice } from "@/lib/currency";

export default function ProductCard({ product, idx = 0 }) {
  const { add } = useCart();
  const { user } = useAuth();
  const [wished, setWished] = React.useState(false);
  const [popping, setPopping] = React.useState(false);

  const toggleWish = async (e) => {
    e.preventDefault();
    if (!user) { toast.message("Sign in to save to wishlist."); return; }
    try {
      const { data } = await api.post(`/wishlist/${product.id}`);
      setWished(data.wishlist.includes(product.id));
      setPopping(true);
      setTimeout(() => setPopping(false), 400);
    } catch {}
  };

  const quickAdd = (e) => {
    e.preventDefault();
    add(product, { quantity: 1, size: product.sizes?.[0] || null, color: product.colors?.[0] || null });
    toast.success(`${product.name} added`);
  };

  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block fade-up"
      style={{ animationDelay: `${idx * 60}ms` }}
    >
      <div className="img-zoom relative aspect-portrait bg-[#EFEFE8]">
        <img
          src={product.images?.[0]}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover"
        />
        <button
          onClick={toggleWish}
          data-testid={`wishlist-toggle-${product.id}`}
          className={`absolute top-4 right-4 w-9 h-9 bg-white/90 flex items-center justify-center transition-all hover:bg-white ${popping ? "heart-pop" : ""}`}
          aria-label="Wishlist"
        >
          <Heart size={15} fill={wished ? "#0A0A0A" : "none"} strokeWidth={1.4} />
        </button>
        {product.is_new && (
          <div className="absolute top-4 left-4 bg-[#C5A059] text-white text-[0.6rem] tracking-[0.25em] uppercase px-3 py-1.5">New</div>
        )}
        {product.is_bestseller && !product.is_new && (
          <div className="absolute top-4 left-4 bg-[#0A0A0A] text-white text-[0.6rem] tracking-[0.25em] uppercase px-3 py-1.5">Best</div>
        )}
        <button
          onClick={quickAdd}
          data-testid={`quick-add-${product.id}`}
          className="absolute bottom-0 left-0 right-0 bg-[#0A0A0A] text-white text-[0.7rem] tracking-[0.25em] uppercase py-3 opacity-0 group-hover:opacity-100 transition-opacity"
        >
          Quick add
        </button>
      </div>
      <div className="mt-4 flex justify-between items-baseline">
        <div>
          <div className="serif text-lg leading-tight">{product.name}</div>
          <div className="overline mt-1">{product.material || product.category}</div>
        </div>
        <div className="text-sm whitespace-nowrap">{formatPrice(product.price, { decimals: 0 })}</div>
      </div>
    </Link>
  );
}
